import { CruiseInfositeController } from 'src/common/controllers/cruise/infosite-controller';
import { CruiseSearchController } from 'src/common/controllers/cruise/search-controller';
export const cruise = [CruiseInfositeController, CruiseSearchController];